module.exports = __webpack_public_path__ + "img/watermark.2bba60d1.png";